// extracted by mini-css-extract-plugin
module.exports = {"container":"Logout_container__1KeJv","homeandlogin":"Logout_homeandlogin__2R_6a"};